import { Button, Tooltip } from '@mui/material'
import React, { useState } from 'react'
import { useAppInfo } from 'AppState'
import { menuIcons } from 'nav/menuIcons'
import { dfin } from 'content/constants'
import SelectMarket from 'components/Inputs/SelectMarket'
import GuideModal from 'resource/guidance/GuideModal'

export default function PageHeaderIcons({name="Explore",variant="nav",guideType,onClick,title,sx={}}) {
  const {dispatchSearch,stateTicker} = useAppInfo()
  const {tickerSelInfo} = stateTicker
  
  const types = {
    "Explore":    <Tooltip title="Explore">
    <Button onClick={()=>dispatchSearch({"searchClick":true})} 
    variant='pageHeader'>
        {menuIcons.Explore}
    Explore</Button>
    </Tooltip>,
    "Guide":<GuideButton variant={variant} sx={sx} guideType={guideType}/>,
     "Calendar":<Tooltip title="Calendar">
     <Button onClick={onClick} variant='pageHeader'>
         {menuIcons.Calendar}
     Calendar</Button>
     </Tooltip>,
     "Active Ticker":
     <Tooltip title={title?title:"Active Ticker"}>
     <Button 
     onClick={onClick}
     variant='pageHeader'>
     <img width={"20px"} height={"20px"} src={`${tickerSelInfo?.[dfin.coLogo]}`}></img>
      {tickerSelInfo?.[dfin.ticker]}
     </Button>
    
     </Tooltip>,
     "MarketRegion":<SelectMarket/>
  }
  return (
    <>
    {types[name]}

    
    </>
  )
}


export function GuideButton({sx={},variant="nav",guideType}) {
  const [guideModal,setGuideModal] = useState(false)

  return(
    <>
    {variant === "sidebar" && 
     <Button onClick={()=>setGuideModal(true)} variant='pageHeader' sx={{color:"black",...sx}}>
     {menuIcons.Guide}</Button>
    }
    {variant==="nav" &&
    <Tooltip title="Guide">
    <Button onClick={()=>setGuideModal(true)} variant='pageHeader' sx={{color:"var(--selectBlue)",...sx}}>
        {menuIcons.Guide}
    Guide</Button>
    </Tooltip>
    }
    {guideModal && <GuideModal guideType={guideType} onClose={()=>setGuideModal(false)}/>}
    </>
  )
}